/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function(){
  $('.main-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    dots: false,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/left-arr.png?v=1607019623'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/rit-arr.png?v=1607019633'>",
    asNavFor: '.thumb-images',
    adaptiveHeight: true
  });
  $('.thumb-images').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-images',
    dots: false,
    arrows: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/left-arr.png?v=1607019623'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/rit-arr.png?v=1607019633'>",
    focusOnSelect: true
  });
  
  var img_heught = $(".prd_img img").height();
  $(".main-images .slick-slide iframe").height(img_heught);

});